import React, { HTMLAttributes, useMemo } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";

import { Hooks, Util } from "@xt/xtbase";
const { useTranslation, useDocumentWidth } = Hooks;
const { getUrl } = Util;
// import store from "store";

import bannerBg from 'assets/images/listing/banner.png'
import bannerApp from 'assets/images/listing/banner-app.png'
import map from 'assets/images/listing/map.png'
import logos from 'assets/images/listing/logos.svg'
import eth from 'assets/images/listing/cooperate/eth.svg';
import polygon from 'assets/images/listing/cooperate/polygon.svg';
import ripple from 'assets/images/listing/cooperate/ripple.svg';
import tron from 'assets/images/listing/cooperate/tron.svg';
import bnb from 'assets/images/listing/cooperate/bnb.svg';
import sol from 'assets/images/listing/cooperate/sol.svg';
import heco from 'assets/images/listing/cooperate/heco.svg';
import apt from 'assets/images/listing/cooperate/apt.svg';
import sui from 'assets/images/listing/cooperate/sui.svg';
import wave from 'assets/images/listing/cooperate/wave.svg';
import opt from 'assets/images/listing/cooperate/opt.svg';
import ava from 'assets/images/listing/cooperate/ava.svg';
import full from 'assets/images/listing/cooperate/full.svg'
import coin from 'assets/images/listing/cooperate/coin.png'
import certik from 'assets/images/listing/cooperate/certik.svg'
import eos from 'assets/images/listing/cooperate/eos.svg'
import arrow from 'assets/images/listing/cooperate/arrow.svg'
import arrowBlack from 'assets/images/listing/blackArrow.png'

import styles from "./index.module.less";

import ListingHistory from "@/components/Pages/Listing/ListingHistory";

interface Props extends HTMLAttributes<HTMLDivElement> {
    attr?: any;
}

const Main: React.FC<Props> = ({ className }) => {
    const t = useTranslation();
    const isPc = (useDocumentWidth() ?? 0) > 768;
    // const {isLogin} = store.user;
    const photoData = useMemo(() => {
        return [
            eth, polygon, ripple, tron, bnb, sol, heco, apt, sui, wave, opt, ava, eos
        ];
    }, []);

    const highhtsData = useMemo(() => [
        {
            img: `${require(`@/assets/images/listing/cooperate/1.svg`)}`,
            title: t('list.launched'),
            dec: t('list.launchedDec')
        },
        {
            img: `${require(`@/assets/images/listing/cooperate/2.svg`)}`,
            title: t('list.industry'),
            dec: t('list.industryDec')
        }, {
            img: `${require(`@/assets/images/listing/cooperate/3.svg`).default}`,
            title: t('list.visits'),
            dec: t('list.visitsDec')
        }, {
            img: `${require(`@/assets/images/listing/cooperate/4.svg`)}`,
            title: t('list.users'),
            dec: t('list.usersDec')
        }, {
            img: `${require(`@/assets/images/listing/cooperate/5.svg`)}`,
            title: t('list.campaigns'),
            dec: t('list.campaignDec')
        }, {
            img: `${require(`@/assets/images/listing/cooperate/6.svg`)}`,
            title: t('list.operation'),
            dec: t('list.operationDec')
        }
    ], []);

    const featuresData = useMemo(() => [
        {
            src: `${require(`@/assets/images/listing/cooperate/features/1.svg`).default}`,
            title: t('list.spot'),
            href: '/trade/btc_usdt',
        },
        {
            src: `${require(`@/assets/images/listing/cooperate/features/2.svg`).default}`,
            title: t('list.listings'),
            href: '/futures/trade/btc_usdt',
        }, {
            src: `${require(`@/assets/images/listing/cooperate/features/3.svg`).default}`,
            title: t('list.nft'),
            href: '/nft',
        }, {
            src: `${require(`@/assets/images/listing/cooperate/features/4.svg`)}`,
            title: t('list.token'),
            href: '/XTStarter',
        }, {
            src: `${require(`@/assets/images/listing/cooperate/features/5.svg`)}`,
            title: t('list.product'),
            href: 'https://www.traderx.vip/en',
            isOther: true,
        }
    ], []);

    const partnersData = useMemo(() => [
        {
            img: `${require(`@/assets/images/listing/cooperate/partners/1.svg`)}`,
            title: t('list.btok'),
            dec: t('list.btokDec')
        },
        {
            img: `${require(`@/assets/images/listing/cooperate/partners/2.svg`)}`,
            title: t('list.cointelegraph'),
            dec: t('list.cointelegraphDec')
        }, {
            img: `${require(`@/assets/images/listing/cooperate/partners/3.svg`)}`,
            title: t('list.simplex'),
            dec: t('list.simplexDec')
        }, {
            img: `${require(`@/assets/images/listing/cooperate/partners/4.svg`)}`,
            title: t('list.gotbitDec'),
            dec: t('list.gotbit')
        }
    ], [])
    const bannerContent = () => {
        return (<div className={styles.bannerLeft}>
            <h2>Spikex</h2>
            <h2>{t('list.title')}</h2>
            <div className={cx(styles.btns)}>
                <div className={cx(styles.btnItem)}>
                    <b>TOP-15</b>
                    <div className={cx(styles.line)}></div>
                    {/* <span>{t('list.cmc')}</span> */}
                    <img src={full} alt="" />
                </div>
                <div className={cx(styles.btnItem, styles.active)}>
                    <b>TOP-20</b>
                    <div className={cx(styles.line)}></div>
                    {/* <span>{t('list.coingecko')}</span> */}
                    <img src={coin} alt="" />
                </div>
            </div>
            <div className={cx(styles.btns, styles.mt20)}>
                <div className={cx(styles.btnItem, styles.active)}>
                    <b>TOP-30</b>
                    <div className={cx(styles.line)}></div>
                    <img src={certik} alt="" />

                </div>
                <div className={cx(styles.btnItem)}>
                    <b>0</b>
                    <div className={cx(styles.line)}></div>
                    <span>{t('list.incidents')}</span>
                </div>
            </div>
            <a href="https://docs.google.com/forms/d/1M2CLTAmqjdssCDnEYHgs4ZbFx1xd_x08sLii5veiT4w/edit#responses" target="_blank" rel="noopener noreferrer">
                <div className={styles.applyBtn}>
                    {t('list.apply')}
                    <img src={arrowBlack} alt="" />
                </div>
            </a>
            <p>{t('list.titleTip')}</p>
            <div className={cx(styles.photos)}>
                <img src={logos} alt="" />
                {/*{photoData.map((s => (*/}
                {/*    <img src={s} alt="" />*/}
                {/*)))}*/}
            </div>
            <a className={styles.findMore} href="https://docs.google.com/spreadsheets/d/1RmDpOGNXRSzY6_gyx2DN1Jdrug0n5YlpXcFksgEArXA/edit?usp=sharing">
                {t('list.findMore')}
                <img src={arrow} alt="" />
            </a>

        </div>);
    }

    return (
        <div className={cx(styles.main, className)}>
            <div className={cx(styles.bannerContainer)} >
                {isPc ? (<div className={styles.content} >
                    {bannerContent()}
                    <div className={cx(styles.bannerRight, isPc ? '' : styles.bannerMobile)} style={{ backgroundImage: `url(${bannerBg})` }}></div>
                </div>) : (<div className={styles.mobileContent} >
                    <div className={cx(styles.bannerRight)} style={{ backgroundImage: `url(${bannerApp})` }}></div>
                    {bannerContent()}
                </div>)}


            </div>
            {/* 第二步 */}
            <div className={cx(styles.highhts, styles.commonStyle)}>
                <h2>{t('list.highhts')}</h2>
                <div>
                    {
                        highhtsData.map(item => (
                            <div className={cx(styles.highItem)}>
                                <img src={item.img} alt="" />
                                <div className={styles.itemRight}>
                                    <h3>{item.title}</h3>
                                    <div className={styles.itemDec}>{item.dec}</div>
                                </div>
                            </div>
                        ))
                    }
                </div>

            </div>
            <div className={cx(styles.user, styles.highhts, styles.commonStyle)}>
                <h2>{t('list.userDistribution')}</h2>
                <img src={map} alt="" />

            </div>
            {/* 第三步 */}
            <div className={cx(styles.features)}>
                <div className={styles.commonStyle}>
                    <h2>{t('list.features')}</h2>
                    <div className={styles.list}>
                        {
                            featuresData.map(item => (
                                <a href={item.isOther ? item.href : getUrl(item.href)} target={item.isOther ? '_blank' : ''} className={styles.featuresItem}>
                                    <div >
                                        <img src={item.src} alt="" />
                                        <h3>{item.title}</h3>
                                    </div>
                                </a>
                            ))
                        }
                    </div>
                </div>
            </div>
            {/* 第四步 */}
            <div className={cx(styles.partners, styles.commonStyle)}>
                <h2>{t('list.partners')}</h2>
                <div>
                    {
                        partnersData.map(item => (
                            <div className={cx(styles.partnersItem)}>
                                <div className={styles.itemRight}>
                                    <h3>{item.title}</h3>
                                    <div className={styles.itemDec}>{item.dec}</div>
                                </div>
                                <div className={styles.imgBg}>
                                    <img src={item.img} alt="" />
                                </div>
                            </div>
                        ))
                    }
                </div>

            </div>
            {/* 第五步 */}
            <div className={cx(styles.commonStyle, styles.history)}>
                <h2>{t('list.history')}</h2>
                <ListingHistory />
            </div>
            {/* 第六步 */}
            <div className={cx(styles.contact, styles.commonStyle)}>
                <h2>{t('list.contact')}</h2>
                <a href="https://docs.google.com/forms/d/1M2CLTAmqjdssCDnEYHgs4ZbFx1xd_x08sLii5veiT4w/edit#responses" target="_blank" rel="noopener noreferrer"> <div className={styles.applyBtn}>{t('list.toContact')}</div></a>

            </div>
        </div>
    );
};

export default observer(Main);
